export default __webpack_public_path__ + "static/media/hero-level-3-chars-mob.82d54965.webp";